<template>
    <span class="text-nowrap">{{ priceFormated }} <span :class="{'text-muted':formated}" v-html="$options.filters.currencySign(price.currency.name)"></span>
    </span>
</template>

<script>
    export default {
        name: "Money",
        props: ['price', 'formated'],
        computed: {
            priceFormated () {
                return (this.price.amount/100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
            }
        }
    }
</script>

<style scoped>

</style>